import { AuthAPI } from './auth.api'

import { SET_LOCATIONS, SET_SELECTED_LOCATION, SET_USER } from './mutations'

export default {
  async loginUser({ commit }, loginData) {
    const { data: { payload } } = await AuthAPI.login(loginData)
    const { user, token } = payload
    user.token = payload['auth-token']
    commit(SET_USER, user)
    return payload
  },
  async loginWithToken({ commit }, token) {
    const { data: { payload } } = await AuthAPI.loginWithToken(token)
    const { user } = payload
    user.token = token
    commit(SET_USER, user)
    return payload
  },
  async logout() {
    await AuthAPI.logout()
  }
}
